import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
    keepAlive: true              if set cache
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/404'),
    hidden: true
  },
  {
    path: '/findpass',
    component: () => import('@/views/login/findpass.vue'),
    hidden: true
  },
  {
    path: '/home',
    component: Layout,
    name: 'Home',
    redirect: '/index',
    children: [{
      path: '/index',
      name: 'Home',
      component: () => import('@/views/home/index'),
      meta: { title: '首页', icon: 'el-icon-s-home' }
    }]
  },
  {
    path: '/',
    component: Layout,
    redirect: '/index',
    name: 'ClientManage',
    meta: { title: '客户管理', icon: 'client' },
    alwaysShow: true,
    children: [{
      path: 'client_list',
      name: 'Client',
      component: () => import('@/views/clientManage/list'),
      meta: { title: '客户列表' }
    }, {
      path: 'client_detail',
      name: 'ClientDetail',
      hidden: true,
      component: () => import('@/views/clientManage/detail'),
      meta: { title: '客户详情', activeMenu: '/client_list' }
    }, {
      path: 'creator_list',
      name: 'CreatorList',
      component: () => import('@/views/clientManage/creator/list'),
      meta: { title: '创客列表', keepAlive: true }
    }, {
      path: 'creator_detail',
      name: 'CreatorDetail',
      hidden: true,
      component: () => import('@/views/clientManage/creator/detail'),
      meta: { title: '创客详情', activeMenu: '/creator_list' }
    }]
  },
  {
    path: '/task',
    component: Layout,
    name: 'Task',
    redirect: '/task/task_list',
    meta: { title: '任务管理', icon: 'task' },
    alwaysShow: true,
    children: [{
      path: 'task_list',
      name: 'TaskTist',
      component: () => import('@/views/task/list'),
      meta: { title: '任务单列表', keepAlive: true }
    }, {
      path: 'task_detail',
      name: 'TaskDetail',
      component: () => import('@/views/task/detail'),
      hidden: true,
      meta: { title: '任务单详情', activeMenu: '/task/task_list' }
    }]
  },
  {
    path: '/trade',
    component: Layout,
    name: 'Trade',
    redirect: '/trade/record',
    meta: { title: '交易管理', icon: 'el-icon-coin' },
    alwaysShow: true,
    children: [{
      path: 'record',
      name: 'Record',
      component: () => import('@/views/trade/record'),
      meta: { title: '支付记录', keepAlive: true }
    }]
  },
  {
    path: '/invoice',
    component: Layout,
    name: 'Invoice',
    redirect: '/invoice/bill',
    meta: { title: '发票中心', icon: 'el-icon-tickets' },
    children: [{
      path: 'bill',
      name: 'Bill',
      component: () => import('@/views/invoice/bill'),
      meta: { title: '开票中心' }
    }, {
      path: 'record',
      name: 'Record',
      component: () => import('@/views/invoice/record'),
      meta: { title: '开票记录' }
    }]
  },
  {
    path: '/account',
    component: Layout,
    name: 'Account',
    redirect: '/account/compay_info',
    meta: { title: '账号资料', icon: 'account' },
    alwaysShow: true,
    children: [{
      path: 'compay_info',
      name: 'CompayInfo',
      component: () => import('@/views/account/compayInfo'),
      meta: { title: '企业资料' }
    }, {
      path: 'employee',
      name: 'Employee',
      component: () => import('@/views/account/employee'),
      meta: { title: '操作员管理', activeMenu: '/account/employee' }
    }]
  },
  // {
  //   path: '/nested',
  //   component: Layout,
  //   redirect: '/nested/menu1',
  //   name: 'Nested',
  //   meta: {
  //     title: '操作员',
  //     icon: 'nested'
  //   },
  //   children: [
  //     {
  //       path: 'menu1',
  //       component: () => import('@/views/nested/menu1/index'), // Parent router-view
  //       name: 'Menu1',
  //       meta: { title: 'Menu1' },
  //       children: [
  //         {
  //           path: 'menu1-1',
  //           component: () => import('@/views/nested/menu1/menu1-1'),
  //           name: 'Menu1-1',
  //           meta: { title: 'Menu1-1' }
  //         },
  //         {
  //           path: 'menu1-2',
  //           component: () => import('@/views/nested/menu1/menu1-2'),
  //           name: 'Menu1-2',
  //           meta: { title: 'Menu1-2' },
  //           children: [
  //             {
  //               path: 'menu1-2-1',
  //               component: () => import('@/views/nested/menu1/menu1-2/menu1-2-1'),
  //               name: 'Menu1-2-1',
  //               meta: { title: 'Menu1-2-1' }
  //             },
  //             {
  //               path: 'menu1-2-2',
  //               component: () => import('@/views/nested/menu1/menu1-2/menu1-2-2'),
  //               name: 'Menu1-2-2',
  //               meta: { title: 'Menu1-2-2' }
  //             }
  //           ]
  //         },
  //         {
  //           path: 'menu1-3',
  //           component: () => import('@/views/nested/menu1/menu1-3'),
  //           name: 'Menu1-3',
  //           meta: { title: 'Menu1-3' }
  //         }
  //       ]
  //     },
  //     {
  //       path: 'menu2',
  //       component: () => import('@/views/nested/menu2/index'),
  //       name: 'Menu2',
  //       meta: { title: 'menu2' }
  //     }
  //   ]
  // },

  // 404 page must be placed at the end !!!
  { path: '*', redirect: '/404', hidden: true }
]

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
